import { get } from './client.js';

const toQS = (p) => {
  const q = Object.entries(p)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  return q ? `?${q}` : '';
};

export const search = (orgId, params) =>
  get(`/orgs/${orgId}/search${toQS(params)}`);
